export enum SearchPageType {
  Unknown = "",
  SEARCH = "1",
  PLP = "2",
  SELECTION_ASSISTANT = "3",
  Campaign = "4",
}

export type GAPageTypeName = "PDP" | "SRP" | "PLP" | "CP" | "Unknown";

export const PDP_GA_NAME = "PDP";
